import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserPermission } from '../model/user';
import { URL_PERMISSION } from './permission';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuardService implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Observable<boolean> | boolean {

    let indexParam = state.url.indexOf('?')
    let path = (indexParam != -1) ? state.url.substring(0, indexParam) : state.url
    let u = URL_PERMISSION.find(item => item.url == path) 

    if (u) {
      const params = route.queryParams
      const companyId = params?.companyId

      return this.authService.getUserPermission(companyId).pipe(
        map((data: UserPermission) => {
          if (!this.authService.checkUserPermission(data, u.permission)) {
            this.router.navigate(['payroll/l'], {queryParams: {...params, ...{menu: u.menu}}})
            return false;
          } else {
            return true
          }
        })
      )
    } else {
      return true
    }

  }
}